import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import { BrowserRouter, Switch, Route } from "react-router-dom";

import {
  ApolloClient,
  ApolloProvider,
  createNetworkInterface
} from "react-apollo";
import registerServiceWorker from "./registerServiceWorker";
import HomePage from "./pages/HomePage";
import CreatePostPage from "./pages/CreatePostPage";
import ShowPostPage from "./pages/ShowPostPage";
import EditPostPage from "./pages/EditPostPage";

const networkInterface = createNetworkInterface({
  uri: "https://api.graph.cool/simple/v1/cjltnf5fy0wsh01654eywxnqz"
});
const client = new ApolloClient({ networkInterface });

networkInterface.use([
  {
    applyMiddleware(req, next) {
      if (!req.options.headers) {
        req.options.headers = {};
      }
      // get the authentication token from local storage if it exists
      if (localStorage.getItem("graphcoolToken")) {
        req.options.headers.authorization = `Bearer ${localStorage.getItem(
          "graphcoolToken"
        )}`;
      }
      next();
    }
  }
]);

ReactDOM.render(<ApolloProvider client={client}>
  <BrowserRouter>
    <Switch>
      <Route path="/create" component={CreatePostPage} />
      <Route path="/edit/:postId" component={EditPostPage} />
      <Route path="/posts/:postId" component={ShowPostPage} />
      <Route path="/" component={HomePage} />
    </Switch>
  </BrowserRouter>
</ApolloProvider>, document.getElementById("root"));
registerServiceWorker();
//



// WEBPACK FOOTER //
// ./src/index.js